import React, { useState, useEffect } from 'react';
import { ArrowSquareOut, CircleNotch, GameController } from '@phosphor-icons/react';
import { PublicNav } from '../components/PublicNav';
import { SiteFooter } from '../components/SiteFooter';
import { HoverPreview } from '../components/HoverPreview';
import { getPublicGames } from '../utils/publicCache';

const API_URL = process.env.REACT_APP_BACKEND_URL || 'https://vakargames.vercel.app';

const PLATFORM_ICONS = {
  steam:       { label: 'Steam',        svg: <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4"><path d="M11.979 0C5.678 0 .511 4.86.022 11.037l6.432 2.658c.545-.371 1.203-.59 1.912-.59.063 0 .125.004.188.006l2.861-4.142V8.91c0-2.495 2.028-4.524 4.524-4.524 2.494 0 4.524 2.031 4.524 4.527s-2.03 4.525-4.524 4.525h-.105l-4.076 2.911c0 .052.004.105.004.159 0 1.875-1.515 3.396-3.39 3.396-1.635 0-3.016-1.173-3.331-2.727L.436 15.27C1.862 20.307 6.486 24 11.979 24c6.627 0 12-5.373 12-12S18.606 0 11.979 0zM7.54 18.21l-1.473-.61c.262.543.714.999 1.314 1.25 1.297.539 2.793-.076 3.332-1.375.263-.63.264-1.319.005-1.949s-.75-1.121-1.377-1.383c-.624-.26-1.29-.249-1.878-.03l1.523.63c.956.4 1.409 1.5 1.009 2.455-.397.957-1.497 1.41-2.454 1.012zm8.397-8.308a3.02 3.02 0 00-3.015-3.015 3.02 3.02 0 00-3.015 3.015 3.02 3.02 0 003.015 3.015 3.02 3.02 0 003.015-3.015zm-5.273-.008a2.262 2.262 0 012.256-2.256 2.262 2.262 0 012.256 2.256 2.262 2.262 0 01-2.256 2.256 2.262 2.262 0 01-2.256-2.256z"/></svg> },
  google_play: { label: 'Google Play',  svg: <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4"><path d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 01-.61-.92V2.734a1 1 0 01.609-.92zm10.89 10.893l2.302 2.302-10.937 6.333 8.635-8.635zm3.199-3.199l2.302 1.332L16.698 12l3.302-2.493zM5.864 2.658L16.8 8.99l-2.302 2.302-8.634-8.634z"/></svg> },
  apple:       { label: 'App Store',    svg: <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4"><path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/></svg> },
  pc:          { label: 'PC',           svg: <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4"><path d="M0 3.449L9.75 2.1v9.451H0m10.949-9.602L24 0v11.4H10.949M0 12.6h9.75v9.451L0 20.699M10.949 12.6H24V24l-12.9-1.801"/></svg> },
  web:         { label: 'Web',          svg: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg> },
  android:     { label: 'Android',      svg: <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4"><path d="M17.523 15.341c-.583 0-1.055.473-1.055 1.056s.473 1.055 1.055 1.055c.583 0 1.056-.473 1.056-1.055s-.474-1.056-1.056-1.056zm-11.046 0c-.583 0-1.055.473-1.055 1.056s.473 1.055 1.055 1.055c.583 0 1.056-.473 1.056-1.055s-.473-1.056-1.056-1.056zm11.405-6.02l1.945-3.368c.108-.188.044-.429-.144-.537-.188-.108-.429-.044-.537.144l-1.97 3.41c-1.479-.672-3.14-1.047-4.89-1.047s-3.411.375-4.89 1.047l-1.97-3.41c-.108-.188-.349-.252-.537-.144-.188.108-.252.349-.144.537l1.945 3.368C3.013 11.18.612 14.04.612 17.353h22.776c0-3.313-2.401-6.173-5.506-8.032z"/></svg> },
  mobile:      { label: 'Mobile',       svg: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4"><rect width="14" height="20" x="5" y="2" rx="2" ry="2"/><path d="M12 18h.01"/></svg> },
};

const GamesPage = () => {
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = 'Games | Vakar Games';
    getPublicGames()
      .then(gamesList => { setGames(gamesList || []); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  const imgUrl = (url) => url?.startsWith('/') ? `${API_URL}${url}` : url;

  return (
    <div className="bg-white text-[#1D1D1F] min-h-screen">
      <PublicNav />

      {/* Page Header: Apple Clean White */}
      <div className="pt-28 pb-12 border-b border-[#E5E5EA]">
        <div className="max-w-[1120px] mx-auto px-6">
          <p className="text-[13px] font-medium text-[#FF6600] mb-2">
            Catalogue
          </p>
          <h1 className="text-4xl md:text-6xl font-semibold tracking-tight text-[#1D1D1F]">
            Games
          </h1>
          <p className="mt-3 text-base md:text-lg text-[#6E6E73] max-w-xl">
            Every title we release. Each one built with deliberate craft and distinct identity.
          </p>
        </div>
      </div>

      {/* ── Games List ──────────────────────────────────────────────── */}
      <div className="max-w-[1120px] mx-auto px-6 py-16">
        {loading ? (
          <div className="text-center py-24 text-[#86868B]">
            <CircleNotch size={32} className="animate-spin mx-auto mb-4" />
            Loading catalogue…
          </div>
        ) : games.length === 0 ? (
          <div className="bg-[#F5F5F7] rounded-2xl p-16 text-center border border-[#E5E5EA]">
            <GameController size={48} className="text-[#86868B] mx-auto mb-4" />
            <h2 className="text-2xl font-semibold text-[#1D1D1F] mb-2">
              In Development
            </h2>
            <p className="text-[#6E6E73] text-sm max-w-sm mx-auto">
              New games are currently in production. Follow the studio devlog for announcements.
            </p>
          </div>
        ) : (
          <div className="space-y-16">
            {games.map((game, idx) => (
              <div
                key={game.slug}
                className={`flex flex-col ${idx % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-10 lg:gap-14 items-center bg-[#F5F5F7] rounded-3xl p-8 lg:p-12 border border-[#E5E5EA]`}
                data-testid={`game-card-${game.slug}`}
              >
                {/* Visual / Screenshot */}
                <div className="lg:w-1/2 w-full rounded-2xl overflow-hidden bg-white border border-[#E5E5EA] shadow-sm">
                  {game.logo_url ? (
                    <img
                      src={imgUrl(game.logo_url)}
                      alt={game.name}
                      className="w-full object-cover"
                    />
                  ) : game.screenshots?.length > 0 ? (
                    <img
                      src={imgUrl(game.screenshots[0])}
                      alt={game.name}
                      className="w-full object-cover"
                    />
                  ) : (
                    <div className="w-full aspect-video flex items-center justify-center bg-[#E5E5EA]">
                      <span className="font-semibold text-[#86868B] text-xl">
                        {game.name}
                      </span>
                    </div>
                  )}
                </div>

                {/* Info */}
                <div className="lg:w-1/2 w-full space-y-5">
                  <div className="flex items-center gap-3 flex-wrap">
                    <h2 className="text-3xl lg:text-4xl font-semibold text-[#1D1D1F] tracking-tight">
                      {game.name}
                    </h2>
                    {game.status === 'coming_soon' && (
                      <span className="text-xs font-semibold text-[#FF6600]">
                        Coming Soon
                      </span>
                    )}
                  </div>

                  {game.description && (
                    <p className="text-[#6E6E73] leading-relaxed text-sm md:text-base">
                      {game.description}
                    </p>
                  )}

                  {game.screenshots?.length > 1 && (
                    <div className="flex gap-2 overflow-x-auto pb-1">
                      {game.screenshots.slice(1, 4).map((s, i) => {
                        const full = imgUrl(s);
                        return (
                          <HoverPreview
                            key={i}
                            previewSrc={full}
                            previewType="image"
                            className="flex-shrink-0"
                          >
                            <img
                              src={full}
                              alt=""
                              className="h-14 w-24 object-cover rounded-lg border border-[#E5E5EA] opacity-80 hover:opacity-100 transition-opacity"
                            />
                          </HoverPreview>
                        );
                      })}
                    </div>
                  )}

                  {game.platforms?.length > 0 && game.status !== 'coming_soon' && (
                    <div className="flex flex-wrap gap-2 pt-2">
                      {game.platforms.map((p, i) => {
                        const pl = PLATFORM_ICONS[p.name];
                        return pl ? (
                          <a
                            key={i}
                            href={p.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center gap-2 px-3.5 py-2 text-xs font-medium rounded-lg bg-white border border-[#D2D2D7] text-[#1D1D1F] hover:border-[#1D1D1F] transition-colors"
                            data-testid={`platform-${p.name}`}
                          >
                            <span className="text-[#6E6E73]">{pl.svg}</span>
                            {pl.label}
                            <ArrowSquareOut size={12} className="text-[#86868B]" />
                          </a>
                        ) : null;
                      })}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <SiteFooter />
    </div>
  );
};

export default GamesPage;
